import { TipoPermissao } from "constants/EnumTipoPermissao";
import { TipoStatusAgendamentoContato } from "constants/EnumTipoStatusAgendamentoContato";
import { usePermissoesContext } from "context/permissoes/PermissoesContext";
import { createContext, useState, useContext } from "react";

export type AgendamentoContatoProps = {
  condominioId: number | null | undefined;
  setCondominioId: (condominioId: number | null) => void;
  unidadeSacadoQuery: string | undefined;
  setUnidadeSacadoQuery: (unidadeSacadoQuery: string) => void;
  dataAgendamento: Date | null | undefined;
  setDataAgendamento: (dataAgendamento: Date | null) => void;
  tipoStatusAgendamento: TipoStatusAgendamentoContato | null | undefined;
  setTipoStatusAgendamento: (tipoStatusAgendamento: TipoStatusAgendamentoContato | null) => void;
  showModalAgendamentoContato: boolean;
  openCloseModalAgendamentoContato: () => void;
  isEdicao: boolean;
  setIsEdicao: (isEdicao: boolean) => void;
  possuiPermissaoVisualizarAgendamento: boolean;
  possuiPermissaoEditarAgendamento: boolean;
  possuiPermissaoIncluirAgendamento: boolean;
  possuiPermissaoExcluirAgendamento: boolean;
  possuiPermissaoExecutarAgendamento: boolean;
  possuiAcessoTelaAgendamento: boolean;
};

const INITIAL_CONTEXT = {
  condominioId: null,
  setCondominioId: () => {},
  unidadeSacadoQuery: undefined,
  setUnidadeSacadoQuery: () => {},
  dataAgendamento: null,
  setDataAgendamento: () => {},
  tipoStatusAgendamento: null,
  setTipoStatusAgendamento: () => {},
  showModalAgendamentoContato: false,
  openCloseModalAgendamentoContato: () => {},
  isEdicao: false,
  setIsEdicao: () => {},
  possuiPermissaoVisualizarAgendamento: false,
  possuiPermissaoEditarAgendamento: false,
  possuiPermissaoIncluirAgendamento: false,
  possuiPermissaoExcluirAgendamento: false,
  possuiPermissaoExecutarAgendamento: false,
  possuiAcessoTelaAgendamento: false,
};

export const AgendamentoContato = createContext<AgendamentoContatoProps>(INITIAL_CONTEXT);

export const AgendamentoContatoProvider = ({ children }: any) => {
  const [condominioId, setCondominioId] = useState<number | null>(null);
  const [unidadeSacadoQuery, setunidadeSacadoQuery] = useState<string>();
  const [dataAgendamento, setDataAgendamento] = useState<Date | null | undefined>(null);
  const [isEdicao, setIsEdicao] = useState<boolean>(false);
  const [showModalAgendamentoContato, setShowModalAgendamentoContato] = useState<boolean>(false);
  const [tipoStatusAgendamento, setTipoStatusAgendamento] = useState<TipoStatusAgendamentoContato | null>(null);

  const { usuarioPossuiPermissao } = usePermissoesContext();

  const changeCondominioId = (condominioId: number | null) => {
    setCondominioId(condominioId);
  };

  const changeUnidadeSacadoQuery = (unidadeSacadoQuery: string) => {
    setunidadeSacadoQuery(unidadeSacadoQuery);
  };

  const changeDataAgendamento = (data: Date | null | undefined) => {
    setDataAgendamento(data);
  };

  const changeTipoStatusAgendamentoContato = (status: TipoStatusAgendamentoContato | null) => {
    setTipoStatusAgendamento(status);
  };

  const openCloseModalAgendamentoContato = () => {
    setShowModalAgendamentoContato(!showModalAgendamentoContato);
  };

  const changeIsEdicao = (isEdicao: boolean) => {
    setIsEdicao(isEdicao);
  };

  const possuiAcessoTelaAgendamento = (): boolean => {
    return (
      usuarioPossuiPermissao("agendamento", TipoPermissao.VISUALIZAR) ||
      usuarioPossuiPermissao("agendamento", TipoPermissao.ALTERAR) ||
      usuarioPossuiPermissao("agendamento", TipoPermissao.INCLUIR) ||
      usuarioPossuiPermissao("agendamento", TipoPermissao.EXCLUIR) ||
      usuarioPossuiPermissao("agendamento", TipoPermissao.EXECUTAR)
    );
  };

  const contextData: AgendamentoContatoProps = {
    condominioId,
    setCondominioId: changeCondominioId,
    unidadeSacadoQuery,
    setUnidadeSacadoQuery: changeUnidadeSacadoQuery,
    dataAgendamento,
    setDataAgendamento: changeDataAgendamento,
    tipoStatusAgendamento,
    setTipoStatusAgendamento: changeTipoStatusAgendamentoContato,
    showModalAgendamentoContato,
    openCloseModalAgendamentoContato,
    isEdicao,
    setIsEdicao: changeIsEdicao,
    possuiPermissaoVisualizarAgendamento: usuarioPossuiPermissao("agendamento", TipoPermissao.VISUALIZAR),
    possuiPermissaoEditarAgendamento: usuarioPossuiPermissao("agendamento", TipoPermissao.ALTERAR),
    possuiPermissaoIncluirAgendamento: usuarioPossuiPermissao("agendamento", TipoPermissao.INCLUIR),
    possuiPermissaoExcluirAgendamento: usuarioPossuiPermissao("agendamento", TipoPermissao.EXCLUIR),
    possuiPermissaoExecutarAgendamento: usuarioPossuiPermissao("agendamento", TipoPermissao.EXECUTAR),
    possuiAcessoTelaAgendamento: possuiAcessoTelaAgendamento(),
  };

  return <AgendamentoContato.Provider value={contextData}>{children}</AgendamentoContato.Provider>;
};

export function useAgendamentoContatoContext() {
  return useContext(AgendamentoContato);
}
